<template>
    <div>
    </div>
</template>

<script>
    export default {
        name : 'inspection-form',
        props : ['deliveryChallanId'],
        data() {
            return {
                data : '',
                URLInspectionItemList: 'inspection-details/show',
                formData : [{
                    ItemId : null,
                    batches: [{
                        Id: null,
                        ApprovedQuantity: null,
                        RejectedQuantity: null,
                        Reason: null,
                    }]
                }],
            }
        },
        methods: {
            getInspectionItems(deliveryChallanId) {
                axios.get(this.URLInspectionItemList + '/' + deliveryChallanId)
                    .then(response => {
                        console.log(response.data)
                        // this.formData = response.data.data
                    }).
                catch(error => {
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            }
        },
        mounted () {
            console.log(this.deliveryChallanId)
            this.getInspectionItems(this.deliveryChallanId);
        },
    }
</script>

<style lang="scss" scoped>

</style>
